export default __webpack_public_path__ + "static/media/2447.7c4038fe.png";